export enum ProfileEnum {
  PROFILE = 'PROFILE',
}

export enum CompanyEnum {
  COMPANY = 'COMPANY',
}
